
import {startCase} from 'lodash';



export const displaySummaryData = (data, key, formatter=null) => {

    if (formatter) return formatter(data);

    if ([null, undefined].includes(data)) {
        return '- -';
    } else if (typeof data === 'boolean') {
        return data ? 'Yes' : 'No';
    } else if (typeof data == "number") {
            return data
    } else if (typeof  data === 'object') {
        return JSON.stringify(data);
    } else {
        if (key && key.includes('note')) {
            return data
        } else {
            return  startCase(data);
        }
    }
}



